import { styled } from 'styled-system/jsx'

const Hero = styled('section', {
  base: {
    paddingY: { base: '64px', md: '88px' },
    paddingX: { base: '16px', md: '32px' },
    background:
      'linear-gradient(180deg, var(--colors-book-primarySoft) 0%, var(--colors-book-surface) 100%)',
  },
})

const HeroInner = styled('div', {
  base: {
    maxWidth: '880px',
    margin: '0 auto',
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
})

const HeroEyebrow = styled('div', {
  base: {
    fontFamily: 'body',
    fontSize: '12px',
    fontWeight: 600,
    color: 'book.primary',
    textTransform: 'uppercase',
    letterSpacing: '0.1em',
  },
})

const HeroHeadline = styled('h1', {
  base: {
    fontFamily: 'display',
    fontSize: { base: '36px', md: '52px' },
    fontWeight: 700,
    lineHeight: 1.05,
    letterSpacing: '-0.02em',
    color: 'app.fg',
    margin: 0,
  },
})

const HeroSubhead = styled('p', {
  base: {
    fontFamily: 'body',
    fontSize: { base: '17px', md: '19px' },
    lineHeight: 1.55,
    color: 'app.fgMuted',
    maxWidth: '640px',
    margin: 0,
  },
})

const CategoriesSection = styled('section', {
  base: {
    paddingY: { base: '64px', md: '96px' },
    paddingX: { base: '16px', md: '32px' },
    backgroundColor: 'app.surface',
  },
})

const CategoriesInner = styled('div', {
  base: {
    maxWidth: '1080px',
    margin: '0 auto',
    display: 'flex',
    flexDirection: 'column',
    gap: { base: '40px', md: '56px' },
  },
})

const CategoryCard = styled('article', {
  base: {
    border: '1px solid',
    borderColor: 'app.border',
    borderRadius: 'lg',
    padding: { base: '28px', md: '40px' },
    display: 'grid',
    gridTemplateColumns: { base: '1fr', md: '0.9fr 1.1fr' },
    gap: { base: '24px', md: '40px' },
    backgroundColor: 'app.surface',
  },
})

const CategoryHead = styled('div', {
  base: {
    display: 'flex',
    flexDirection: 'column',
    gap: '14px',
  },
})

const CategoryTitle = styled('h2', {
  base: {
    fontFamily: 'display',
    fontSize: { base: '24px', md: '28px' },
    fontWeight: 700,
    color: 'app.fg',
    margin: 0,
    lineHeight: 1.15,
    letterSpacing: '-0.01em',
  },
})

const CategoryBody = styled('p', {
  base: {
    fontFamily: 'body',
    fontSize: '16px',
    lineHeight: 1.6,
    color: 'app.fgMuted',
    margin: 0,
  },
})

const CategoryBullets = styled('ul', {
  base: {
    listStyle: 'none',
    padding: 0,
    margin: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: '14px',
  },
})

const CategoryBullet = styled('li', {
  base: {
    fontFamily: 'body',
    fontSize: '15px',
    lineHeight: 1.5,
    color: 'app.fg',
    paddingLeft: '28px',
    position: 'relative',
    _before: {
      content: '""',
      position: 'absolute',
      left: '6px',
      top: '7px',
      width: '8px',
      height: '8px',
      borderRadius: '50%',
      backgroundColor: 'book.primary',
    },
  },
})

export {
  Hero,
  HeroInner,
  HeroEyebrow,
  HeroHeadline,
  HeroSubhead,
  CategoriesSection,
  CategoriesInner,
  CategoryCard,
  CategoryHead,
  CategoryTitle,
  CategoryBody,
  CategoryBullets,
  CategoryBullet,
}
